import { getInitData } from '../api/data'
import { SET_INIT_DATA } from '../reducers/data'

export const init_data = (token) => {
  return (dispatch) => {
    getInitData(token)
      .then((data) => dispatch({ type: SET_INIT_DATA, data }))
      .catch(() => {})
  }
}
